import React, { createContext, useState, useEffect, useCallback } from "react";
import { getCareGapSummary } from "../../../utils/services/APP/CareGAP/getCareGapSummary";
import { getCareGapsByCip } from "../../../utils/services/APP/CareGAP/getCareGapsByCip";
import { useValidToken } from "../../../hooks/useValidToken";

export const CareGapContext = createContext();

export const CareGapProvider = ({ children }) => {
  const [careGapSummary, setCareGapSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const [selectedCip, setSelectedCip] = useState(null);
  const [careGapDetails, setCareGapDetails] = useState([]);

  const [page, setPage] = useState(0); // 0-based for MUI DataGrid
  const [pageSize, setPageSize] = useState(50);

  const { isValid, authLoading } = useValidToken();

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getCareGapSummary(page + 1, pageSize); // API espera 1-based
      setCareGapSummary(res.data.map((item) => ({ ...item, id: item.cipId })));
      setTotal(res.total);
    } catch (error) {
      console.error('[CareGapContext] Error loading summary:', error);
    }
    setLoading(false);
  }, [page, pageSize]);

  const fetchCareGapDetails = useCallback(async (cipId) => {
    setDetailsLoading(true);
    try {
      const res = await getCareGapsByCip(cipId);
      setCareGapDetails(res);
      setSelectedCip(cipId);
    } catch (error) {
      console.error("Error loading care gaps for CIP:", cipId, error);
    }
    setDetailsLoading(false);
  }, []);

  useEffect(() => {
    if (!isValid || authLoading) return;
    fetchSummary();
  }, [authLoading, isValid, fetchSummary]);

  return (
    <CareGapContext.Provider
      value={{
        careGapSummary,
        total,
        page,
        pageSize,
        loading,
        detailsLoading,
        careGapDetails,
        selectedCip,
        setPage,
        setPageSize,
        fetchCareGapDetails,
        setSelectedCip
      }}
    >
      {children}
    </CareGapContext.Provider>
  );
};
